import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Button as AntButton } from "antd";
import { Box, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../pages/LoadingSpinner";
import "./Signup.css";

const { Title, Text } = Typography;

const SignupPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/dashboard");
    }, 2000);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <Row
      style={{
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: isMobile ? 0 : "20px 150px",
      }}
    >
     
      {!isMobile && (
        <Col
          xs={0}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            padding: "40px",
            backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0), rgba(52,152,219,0.8)), url('/images/login5.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "#fff",
            position: "relative",
            minHeight: "500px",
          }}
        >
          <div style={{ zIndex: 2 }}>
            <h3 style={{ fontSize: "19px", margin: 0, fontWeight: "600" }}>
              Empowering Healthcare, One Click at a Time:
            </h3>
            <p style={{ fontSize: "16px", marginTop: "8px" }}>
              Your Health. Your Records. Your Control.
            </p>
          </div>
        </Col>
      )}

     
      <Col
        xs={24}
        md={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#ffffff",
        }}
      >
        <Card
          className="signup-card"
          style={{
            width: isMobile ? "100%" : "100%",
            maxWidth: isMobile ? "430px" : "450px",
            padding: "15px",
            borderRadius: "10px",
          }}
        >
         
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/images/logo.jpg"
              alt="Logo"
              style={{ width: 60, height: 60, marginBottom: 10 }}
            />
            <Title level={4} style={{ margin: 0 }}>
              Create Account
            </Title>
            <Text type="secondary">Sign up to get started</Text>
          </div>

        
          <div style={{ marginTop: "20px" }}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={email}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setEmail(e.target.value)}
   sx={{
    "& .MuiInputBase-root": {
      height: { xs: 40, sm: 50 },
      fontSize: { xs: 12, sm: 14 },
      marginBottom: 2,
    },
    "& label.Mui-focused": {
      color: "#037589",  
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#070707ff",
         borderWidth:"1px"
      },
    },
  }} 
            />
            <TextField
              label="Password"
              variant="outlined"
              type="password"
              fullWidth
              value={password}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setPassword(e.target.value)}
     sx={{
    "& .MuiInputBase-root": {
      height: { xs: 40, sm: 50 },
      fontSize: { xs: 12, sm: 14 },
      marginBottom: 2,
    },
    "& label.Mui-focused": {
      color: "#037589",  
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#070707ff",
         borderWidth:"1px"
      },
    },
  }} 
            />
            <TextField
              label="Confirm Password"
              variant="outlined"
              type="password"
              fullWidth
              value={confirmPassword}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setConfirmPassword(e.target.value)}
   sx={{
    "& .MuiInputBase-root": {
      height: { xs: 40, sm: 50 },
      fontSize: { xs: 12, sm: 14 },
      marginBottom: 2,
    },
    "& label.Mui-focused": {
      color: "#037589",  
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#070707ff",
         borderWidth:"1px"
      },
    },
  }}      />
          </div>

        
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <AntButton
              type="primary"
              style={{
                width: "120px",
                height: "36px",
                borderRadius: 8,
                backgroundColor: "#037589ff",
                borderColor: "#037589ff",
              }}
              onClick={handleSubmit}
            >
              Sign Up
            </AntButton>
          </div>

         
          <Box sx={{ width: "100%", mt: 3, textAlign: "center" }}>
            <Text>
              Already have an account?{" "}
              <AntButton
                type="link"
                style={{ padding: 0, marginLeft: "5px" }}
                onClick={() => navigate("/")}
              >
                Login
              </AntButton>
            </Text>
          </Box>
        </Card>
      </Col>
    </Row>
  );
};

export default SignupPage;
